const useValidate = () => {
  // func: check if input is empty
  const isInputEmpty = (inputName, inputValue, t) => {
    const trimmedValue = inputValue.trim()
    return !trimmedValue ? t(`formErrors.${inputName}.empty`) : ''
  }
  // func: check if email is valid
  const isEmailValid = (inputName, inputValue, t) => {
    // eslint-disable-next-line max-len
    const regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9\u00C0-\u024F\u0400-\u04FF]+\.)+[a-zA-Z\u00C0-\u024F\u0400-\u04FF]{2,}))$/
    return !regExp.test(inputValue) ? t(`formErrors.${inputName}.valid`) : ''
  }
  // func: check if tel is valid
  const isTelValid = (inputName, inputValue, t) => {
    const isNumber = /^\d+$/.test(inputValue)
    return !isNumber ? `Das ${inputName} Input muss nur die Nummern haben` : ''
  }
  // func: check if input has minimum length
  const minInputLength = (inputName, inputValue, minLength, t) => {
    return inputValue.length < minLength ? t(`formErrors.${inputName}.minlength`) : ''
  }
  // func: check if input has maximum length
  const maxInputLength = (inputName, inputValue, maxLength) => {
    return inputValue.length > maxLength ? `Der ${inputName} muss maximum ${maxLength} Buchstaben haben` : ''
  }
  // func: check if house number is valid
  const isHouseNumberValid = (inputName, inputValue) => {
    const isNumber = /^\d+$/.test(inputValue)
    return !isNumber ? `Das ${inputName} Input muss nur die Nummern haben` : ''
  }
  // func: check if postal number is valid
  const isPostalNumberValid = (inputName, inputValue) => {
    const isNumber = /^\d+$/.test(inputValue)
    return !isNumber ? `Das ${inputName} Input muss nur die Nummern haben` : ''
  }
  const isOnlyLetters = (inputName, inputValue, t) => {
    const isLetter = /[a-zA-Z]+/.test(inputValue)
    return !isLetter ? t(`formErrors.${inputName}.onlyLetters`) : ''
  }

  return {
    isInputEmpty,
    minInputLength,
    maxInputLength,
    isEmailValid,
    isTelValid,
    isHouseNumberValid,
    isPostalNumberValid,
    isOnlyLetters
  }
}

export default useValidate
